import { createI18n } from 'vue-i18n'
import enLang from '@src/locales/en.json'
import urLang from '@src/locales/ur.json'
import arLang from '@src/locales/ar.json'

let options = {
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: { en: enLang, ur: urLang, ar: arLang },
  legacy: false,
  globalInjection: true,
}

const i18n = createI18n(options)
export default i18n
